export default {
  SET_CONVERTED_IMAGE(state, { originalUrl, convertedUrl }) {
    state.convertedImages = {
      ...state.convertedImages,
      [originalUrl]: convertedUrl
    };
  },

  SET_CONVERSION_STATUS(state, { url, status }) {
    state.conversionStatus = {
      ...state.conversionStatus,
      [url]: status
    };
  },

  REMOVE_CONVERTED_IMAGE(state, originalUrl) {
    const newConverted = { ...state.convertedImages };
    const newStatus = { ...state.conversionStatus };
    delete newConverted[originalUrl];
    delete newStatus[originalUrl];
    state.convertedImages = newConverted;
    state.conversionStatus = newStatus;
  },

  CLEAR_CONVERTED_IMAGES(state) {
    state.convertedImages = {};
    state.conversionStatus = {};
  }
};